// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1auNf","rootMobile":"styles_rootMobile__pz6fB"};